export default {"src":"/_next/static/media/Contacts.5fbfe558.svg","height":315,"width":342};